module.exports = __webpack_public_path__ + "img/10.a0e0d1f5.png";